import NoteIcon from '@mui/icons-material/Note'
import { Link, Stack, Tooltip, Typography, Zoom } from '@mui/material'
import {} from 'react'
import { Link as RouterLink } from 'react-router'
import { BulkPaymentStepperQuery } from '../../gql/graphql'
import {} from '../../utils/currencyFormatter'
import NoteDisplay from '../NoteDisplay'

export default function RfqCell({ rfq }: { rfq: BulkPaymentStepperQuery['Rfqs'][0] }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="column" minWidth="10em">
        <Link component={RouterLink} to={`/order/${rfq.id}`} tabIndex={-1}>
          {rfq.project.name}
        </Link>
        <Typography variant="caption">{rfq.client.name}</Typography>
      </Stack>
      {rfq.note && (
        <Tooltip
          title={<NoteDisplay value={rfq.note} />}
          leaveDelay={500}
          slots={{
            transition: Zoom,
          }}
          arrow
          placement="top"
          slotProps={{
            arrow: { sx: { color: '#fffef2' } },
            tooltip: {
              sx: {
                backgroundColor: '#fffef2',
                color: 'text.primary',
                boxShadow: 8,
                maxWidth: '20em',
                border: '1px solid #ccc',
              },
            },
          }}
        >
          <NoteIcon fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  )
}
